var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMatic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1723 19.5203C29.7337 19.2671 29.1697 19.2671 28.6684 19.5203L25.1593 21.6093L22.7781 22.9387L19.3316 25.0277C18.893 25.2809 18.329 25.2809 17.8277 25.0277L15.1332 23.3818C14.6945 23.1286 14.3812 22.6222 14.3812 22.0524V18.8872C14.3812 18.3808 14.6319 17.8744 15.1332 17.5579L17.8277 15.9753C18.2663 15.7221 18.8303 15.7221 19.3316 15.9753L22.0261 17.6212C22.4648 17.8744 22.7781 18.3808 22.7781 18.9505V21.0396L25.1593 19.6469V17.4946C25.1593 16.9881 24.9086 16.4817 24.4073 16.1652L19.3943 13.1899C18.9556 12.9367 18.3916 12.9367 17.8903 13.1899L12.752 16.2285C12.2507 16.4817 12 16.9881 12 17.4946V23.4451C12 23.9515 12.2507 24.458 12.752 24.7745L17.8277 27.7498C18.2663 28.003 18.8303 28.003 19.3316 27.7498L22.7781 25.724L25.1593 24.3314L28.6057 22.3056C29.0444 22.0524 29.6084 22.0524 30.1097 22.3056L32.8042 23.8882C33.2428 24.1414 33.5561 24.6479 33.5561 25.2176V28.3828C33.5561 28.8892 33.3055 29.3956 32.8042 29.7122L30.1723 31.2948C29.7337 31.548 29.1697 31.548 28.6684 31.2948L25.9739 29.7122C25.5352 29.459 25.2219 28.9525 25.2219 28.3828V26.3571L22.8407 27.7498V29.8388C22.8407 30.3452 23.0914 30.8516 23.5927 31.1682L28.6684 34.1434C29.107 34.3966 29.671 34.3966 30.1723 34.1434L35.248 31.1682C35.6867 30.9149 36 30.4085 36 29.8388V23.8249C36 23.3185 35.7493 22.8121 35.248 22.4955L30.1723 19.5203Z",
    fill: "#8247E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatic);
export default __webpack_public_path__ + "static/media/matic.51867b7eb12aabdacb961bee4e4769f2.svg";
export { ForwardRef as ReactComponent };